export function getIntersection<T>(list1: T[], list2: T[]): T[] {
	const set2 = new Set(list2); // Convert second list to a Set for efficient lookup
	return list1.filter(item => set2.has(item));
}

export function intersectAll<T>(...lists: T[][]): T[] {
	if (lists.length === 0) return []; // No lists, return empty
	if (lists.length === 1) return lists[0]; // Single list, return it

	// Start with the first list, intersect with others one by one
	return lists.reduce((intersection, currentList) => {
		const currentSet = new Set(currentList);
		return intersection.filter(item => currentSet.has(item));
	});
}

export function symmetricDifference<T>(list1: T[], list2: T[]): T[] {
	const set1 = new Set(list1);
	const set2 = new Set(list2);

	return [...list1.filter(item => !set2.has(item)), ...list2.filter(item => !set1.has(item))];
}

export const create2dArray = <T>(rows: number, cols: number, value: T) => {
	return Array.from({ length: rows }, () => {
		return Array.from<unknown, T>({ length: cols }, () => value);
	});
};

export const hasOverlap = (listA: string[], listB: string[]): boolean => {
	const setA = new Set(listA);

	for (const item of listB) {
		if (setA.has(item)) {
			return true;
		}
	}

	return false;
};
